module.exports = __webpack_public_path__ + "img/boardImage.5e5fcd80.png";